import { fetcher } from 'services/helpers/responseHandler'

const list = ({
  allSubsidiary = false,
  isGds = false,
  firstName = null,
  lastName = null,
  confirmationCode = null,
  checkIn = null,
  checkOut = null,
  bookingStartDate = null,
  bookingEndDate = null,
  cancelledOn = null,
  count = 250,
  bookingStatus = null,
  subsidiaryId = null,
  bookedBy = null
}) =>
  fetcher.post('bookings/list', {
    allSubsidiary,
    isGds,
    firstName,
    lastName,
    confirmationCode,
    checkIn,
    checkOut,
    bookingStartDate,
    bookingEndDate,
    cancelledOn,
    count,
    bookingStatus,
    subsidiaryId,
    bookedBy
  })

const one = ({ bookingId }) => fetcher.get('bookings/one', { bookingId })

const availability = async ({ subscriberId, checkIn, checkOut, guestCount = 2 }) =>
  fetcher.post('bookings/availability', { subscriberId, checkIn, checkOut, guestCount })

const update = async ({
  subscriberHotelBookingId,
  totalRate,
  checkIn,
  checkOut,
  transactionStatus
}) =>
  fetcher.put('bookings/change/billing', {
    subscriberHotelBookingId,
    totalRate,
    checkIn,
    checkOut,
    transactionStatus
  })

const edit = async ({
  bookingId,
  providerConfirmationCode,
  bookingDate,
  cancellationDate,
  checkIn,
  checkOut,
  totalTaxesAndFees,
  totalRate,
  rateCode,
  roomName,
  adults,
  children,
  transactionStatus,
  guestFirstName,
  guestLastName,
  guestPhone,
  guestEmail,
  guestLoyaltyId
}) =>
  fetcher.patch('bookings', {
    bookingId,
    providerConfirmationCode,
    bookingDate,
    cancellationDate,
    checkIn,
    checkOut,
    totalTaxesAndFees,
    totalRate,
    rateCode,
    roomName,
    adults,
    children,
    transactionStatus,
    guestInfo: {
      firstName: guestFirstName,
      lastName: guestLastName,
      phone: guestPhone,
      email: guestEmail,
      loyaltyId: guestLoyaltyId
    }
  })

const otaPrices = ({ checkIn, checkOut }) =>
  fetcher.get('bookings/ota/prices', { checkIn, checkOut })

const setBookingAsCompleted = ({ bookingId, subsidiaryId }) =>
  fetcher.patch('bookings/completing', { bookingId, subsidiaryId })

const unmaskBookingDetails = ({ paymentAccountId }) =>
  fetcher.get(`accounts/paymentaccounts/${paymentAccountId}`)

const refund = ({ subsidiaryId, bookingId, amount }) =>
  fetcher.post('payments/bookings/refund', {
    subsidiaryId,
    bookingId,
    amount: Number(amount)
  })

const otaBookings = ({
  year,
  month,
  kind,
  parentChainCode,
  city,
  groupId,
  state,
  isOtaOnly
}) =>
  fetcher.get('bookings/ota/comparison/monthly', {
    year,
    month,
    subsidiaryFilterKind: kind,
    city,
    groupId,
    state,
    isOtaOnly,
    parentChainCode:
      parentChainCode === 'all' ? '' : parentChainCode ? parentChainCode : ''
  })

const bookingsApi = {
  list,
  one,
  update,
  edit,
  otaPrices,
  setBookingAsCompleted,
  unmaskBookingDetails,
  availability,
  refund,
  otaBookings
}

export default bookingsApi
